import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import moment from "moment";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

import ClockedIn2 from "./Cards/ClockedIn2";
import EmployeesActivities from "./Cards/EmployeesActivities";
import ActivityHoursPlanned from "./Cards/ActivityHoursPlanned";
import ActivityHoursByEmployee from "./Cards/ActivityHoursByEmployee";
import LoaderView from "components/LoaderView";
import CardLayout from "pages/Dashboard2.0/components/CardLayout";
import ActivityByJobRole from "./ActivityByJobRole";
import Menu from "@material-ui/core/Menu";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  getManagerEmails,
  selectedManagerForApproval,
  selectedWorkerOnReview,
  selectedWeekOnReview,
  selectedMonthOnReport,
  selectedTeamOnReview,
  getCountries,
} from "redux/actions/appActions";
import {
  getClockedInReport,
  getActivityGroupReportData,
  getActivitesByJobFamilyReport,
  getJobFamilyReportData,
  getWorkersListByMgr,
  getActivityHoursReportData,
  getDashboardCollection,
  getDscDashboardCollection,
} from "utils/report";
import { MY_TEAM, MANAGE_FOR_BY_COUNTRY } from "config/CONSTANTS";
import { getStartOfWeek, getEndOfWeek, properCase, isEmptyObject } from "utils";
import {
  getDistrictBuildingMapForIMWarehouse,
  getParentManager,
  getWeekNumber,
} from "services";
import {
  convertCamelToNormalCase,
  getTranslatedActivityGroupFromCamelCase,
} from "./components/utils";
import { getFullName } from "utils";

export const HomeView = () => {
  const [clockedInReportData, setClockedInReportData] = useState({});
  const [clockedInReportDataLoading, setClockedInReportDataLoading] =
    useState(true);
  const [employeesUnderManager, setEmployeesUnderManager] = useState(null);
  const [employeesUnderManagerLoading, setEmployeesUnderManagerLoading] =
    useState(true);

  const [jobFamilyChart, setJobFamilyChart] = useState([]);
  const [jobFamilyChartLoading, setJobFamilyChartLoading] = useState(true);
  const [chart, setChart] = useState([]);
  const [chartLoading, setChartLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [checked, setChecked] = useState([]);
  const [plannedActivityHoursData, setPlannedActivityHoursData] = useState([]);
  const [employeeActivityHoursData, setEmployeeActivityHoursData] = useState({
    employeeHoursData: {},
    employeeHoursTotalData: {},
  });
  const [activityHoursDataLoading, setActivityHoursDataLoading] =
    useState(true);
  const [districtBuildingMap, setDistrictBuildingMap] = useState({});
  const [districtBuildingMapLoading, setDistrictBuildingMapLoading] =
    useState(true);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState({});
  const [newOptions, setNewOptions] = useState([]);
  const [loggedinPlusDelegate, setLoggedinPlusDelegate] = useState([]);

  const { t } = useTranslation();
  const { isAuthenticated, user } = useSelector((state) => state.user.auth);

  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);
  const options = [
    // { name: "Leaves", key: 0 },
    { name: "Meals", key: 1 },
  ];

  useEffect(() => {
    if (user.workerId) {
      getParentManager(user.workerId).then((querySnapshot) => {
        let optionsAvailable = querySnapshot.filter(
          (elem, index) =>
            querySnapshot.findIndex(
              (obj) => obj.managerId === elem.managerId
            ) === index
        );
        setNewOptions(optionsAvailable);
      });
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      let loggedinCountryManagers = managerOptions.filter(
        (item) => item.managerCountry === user.country
      );

      let totalManagers = [...loggedinCountryManagers, ...newOptions];

      const userManagerObject = {
        managerCountry: user.country,
        managerEmail: user.email,
        managerFirstName: user.firstName,
        managerId: user.workerId,
        managerLastName: user.lastName,
      };

      totalManagers.push(userManagerObject);

      let removeRepeated = totalManagers.filter(
        (elem, index) =>
          totalManagers.findIndex((obj) => obj.managerId === elem.managerId) ===
          index
      );

      setLoggedinPlusDelegate(removeRepeated);
    }
  }, [newOptions]);

  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null) {
      let managerDetails = appConfig.managerEmails;
      managerDetails = managerDetails.filter(
        (record) => record.managerId !== user.workerId
      );
      setManagerOptions(managerDetails);
    }
  }, [user, appConfig.managerEmails]);

  useEffect(() => {
    console.log("user.workerId", user);
    var startDate = moment().startOf("week").format("YYYY-MM-DD");
    var endDate = moment().endOf("week").format("YYYY-MM-DD");
    console.log(startDate, endDate);

    // setActivityHoursDataLoading(true);
    setDistrictBuildingMapLoading(true);

    // getActivityHoursReportData(user.country, startDate)
    //   .then((data) => {
    //     const plannedHoursData = {};
    //     const employeeHoursData = {};
    //     const employeeHoursTotalData = {};
    //     const [plannedData, employeeData] = data;
    //     if (!isEmptyObject(plannedData)) {
    //       for (const building in plannedData) {
    //         plannedHoursData[building] = [];
    //         for (const activity in plannedData[building]) {
    //           const activityHours = plannedData[building][activity];
    //           plannedHoursData[building].push({
    //             activityName: convertCamelToNormalCase(activity),
    //             activityHours: activityHours.toFixed(2),
    //           });
    //         }
    //       }
    //     }

    //     if (!isEmptyObject(employeeData)) {
    //       for (const building in employeeData) {
    //         employeeHoursData[building] = {};
    //         employeeHoursTotalData[building] = {};
    //         for (const activity in employeeData[building]) {
    //           employeeHoursData[building][convertCamelToNormalCase(activity)] =
    //             [];
    //           employeeHoursTotalData[building][
    //             convertCamelToNormalCase(activity)
    //           ] = [];
    //           let totalHours = 0;
    //           for (const employee in employeeData[building][activity]) {
    //             const [employeeName, employeeId] = employee.split("_");
    //             const employeeNameId = `${convertCamelToNormalCase(
    //               employeeName
    //             )} (${employeeId})`;
    //             const activityHours =
    //               employeeData[building][activity][employee];
    //             employeeHoursData[building][
    //               convertCamelToNormalCase(activity)
    //             ].push({
    //               employeeNameId: employeeNameId,
    //               activityHours: activityHours.toFixed(2),
    //             });

    //             totalHours += activityHours;
    //             const employeeHours =
    //               employeeData[building][activity][employee];

    //             employeeHoursTotalData[building][
    //               convertCamelToNormalCase(activity)
    //             ] = {
    //               ...employeeHoursTotalData[building][
    //                 convertCamelToNormalCase(activity)
    //               ],
    //               [employeeNameId]: employeeHours.toFixed(2),
    //               totalHours: totalHours.toFixed(2),
    //             };
    //           }
    //         }
    //       }
    //     }

    //     setPlannedActivityHoursData(plannedHoursData);
    //     setEmployeeActivityHoursData({
    //       employeeHoursData: employeeHoursData,
    //       employeeHoursTotalData: employeeHoursTotalData,
    //     });
    //     setActivityHoursDataLoading(false);
    //   })
    //   .catch((error) => {
    //     setActivityHoursDataLoading(false);
    //     console.log("getActivityHoursReportData err ", error);
    //   });

    getDistrictBuildingMapForIMWarehouse(user.country)
      .then((data) => {
        setDistrictBuildingMap(data);
        setDistrictBuildingMapLoading(false);
      })
      .catch((error) => {
        setDistrictBuildingMapLoading(false);
        console.log("getDistrictBuildingMapForIMWarehouse err ", error);
      });

    const userManagerObject = {
      managerCountry: user.country,
      managerEmail: user.email,
      managerFirstName: user.firstName,
      managerId: user.workerId,
      managerLastName: user.lastName,
    };

    setSelectedManager(userManagerObject);

    if (appConfig !== null) {
      dispatch(getManagerEmails());
      dispatch(getCountries());
      dispatch(selectedManagerForApproval(null));
      dispatch(selectedWorkerOnReview({}));
      dispatch(selectedWeekOnReview(null));
      dispatch(selectedMonthOnReport(null));
      dispatch(selectedTeamOnReview({ team: MY_TEAM }));
    }
  }, [user]);

  useEffect(() => {
    var startDate = moment().startOf("week").format("YYYY-MM-DD");
    var endDate = moment().endOf("week").format("YYYY-MM-DD");

    if (selectedManager.managerId) {
      setChartLoading(true);
      setClockedInReportDataLoading(true);
      setEmployeesUnderManagerLoading(true);
      setJobFamilyChartLoading(true);

      const weekNumber = getWeekNumber(new Date());

      getDashboardCollection(selectedManager.managerId, weekNumber)
        .then((data) => {
          let clockedInData = {};
          let chartData = [];
          let jobRoleChartData = [];
          if (!isEmptyObject(data)) {
            // Clocked In card data
            clockedInData = data.clockedInCard;

            // Pie Chart data
            const activityGroupTotals = data.activityGroupTotals;
            Object.keys(activityGroupTotals).map((activityGroup) => {
              // Remove this condition later for meal and leave checkbox
              if (activityGroup !== "meal" && activityGroup !== "leave") {
                chartData.push({
                  name: getTranslatedActivityGroupFromCamelCase(activityGroup),
                  value: activityGroupTotals[activityGroup],
                });
              }
            });

            // Job Role Bar Chart data
            const jobRoleTotals = data.jobRoleTotals;
            Object.keys(jobRoleTotals).map((jobRole) => {
              const activityGroupHours = jobRoleTotals[jobRole];
              // Remove this deletion later for meal and leave checkbox
              delete activityGroupHours.leave;
              delete activityGroupHours.meal;
              const activityGroupHoursObject = {};
              let totalactivityGroupHours = 0;
              if (!isEmptyObject(activityGroupHours)) {
                Object.keys(activityGroupHours).map((activityGroup) => {
                  activityGroupHoursObject[
                    getTranslatedActivityGroupFromCamelCase(activityGroup)
                  ] = activityGroupHours[activityGroup];
                  totalactivityGroupHours += activityGroupHours[activityGroup];
                });

                jobRoleChartData.push({
                  Name: convertCamelToNormalCase(jobRole),
                  Total: totalactivityGroupHours,
                  ...activityGroupHoursObject,
                });
              }
            });
          }
          setClockedInReportData(clockedInData);
          setClockedInReportDataLoading(false);

          setChart(chartData);
          setChartLoading(false);

          setJobFamilyChart(jobRoleChartData);
          setJobFamilyChartLoading(false);
        })
        .catch((error) => {
          setClockedInReportDataLoading(false);
          setChartLoading(false);
          setJobFamilyChartLoading(false);
        });

      // getActivitesByJobFamilyReport(
      //   selectedManager.managerId,
      //   startDate,
      //   endDate
      // )
      //   .then((data) => {
      //     console.log("Activity Group report data", data);
      //     setChart(data);
      //     setChartLoading(false);
      //   })
      //   .catch((error) => {
      //     setChartLoading(false);
      //     console.log("getActivitesByJobFamilyReport err ", error);
      //   });

      // getClockedInReport(selectedManager.managerId, startDate, endDate)
      //   .then((data) => {
      //     console.log("getClockedInReport data: ", data);
      //     setClockedInReportData(data);
      //     setClockedInReportDataLoading(false);
      //   })
      //   .catch((error) => {
      //     setClockedInReportDataLoading(false);
      //     console.log("getClockedInReport err ", error);
      //   });

      // getJobFamilyReportData(selectedManager.managerId, startDate, endDate)
      //   .then((data) => {
      //     console.log("Job family report data", data);
      //     setJobFamilyChart(data);
      //     setJobFamilyChartLoading(false);
      //   })
      //   .catch((error) => {
      //     setJobFamilyChartLoading(false);
      //     console.log("getJobFamilyReportData err ", error);
      //   });

      getWorkersListByMgr(selectedManager.managerId)
        .then((data) => {
          console.log("getWorkersListByMgr data: ", data);
          setEmployeesUnderManager(data);
          setEmployeesUnderManagerLoading(false);
        })
        .catch((error) => {
          setEmployeesUnderManagerLoading(false);
          console.log("getWorkersListByMgr err ", error);
        });
    }
  }, [selectedManager]);

  useEffect(() => {
    const weekNumber = getWeekNumber(new Date());

    setActivityHoursDataLoading(true);

    setPlannedActivityHoursData({});
    setEmployeeActivityHoursData({
      employeeHoursData: {},
      employeeHoursTotalData: {},
    });

    if (!isEmptyObject(selectedBuilding)) {
      getDscDashboardCollection(weekNumber, selectedBuilding)
        .then((res) => {
          // Activity Hours planned
          if(res.length<1){
            setPlannedActivityHoursData({});
            setEmployeeActivityHoursData({
              employeeHoursData: {},
              employeeHoursTotalData: {},
            });
          }else{
          const data = res[0];
          const plannedHoursData = [];
          const employeeHoursData = {};
          const employeeHoursTotalData = {};

          const activitiesData = data.activities;

          Object.keys(activitiesData).forEach((activity) => {
            const activityName = convertCamelToNormalCase(activity);
            plannedHoursData.push({
              activityName: activityName,
              activityHours: activitiesData[activity].actualDuration,
            });

            employeeHoursTotalData[activityName] = {
              totalHours: activitiesData[activity].actualDuration,
            };
            employeeHoursData[activityName] = [];

            Object.keys(activitiesData[activity]).forEach((employee) => {
              if (employee !== "actualDuration") {
                const employeeNameId = `${activitiesData[activity][employee].workerName} (${employee})`;

                employeeHoursTotalData[activityName] = {
                  ...employeeHoursTotalData[activityName],
                  [employeeNameId]: activitiesData[activity][employee].duration,
                };

                employeeHoursData[activityName].push({
                  activityHours: activitiesData[activity][employee].duration,
                  employeeNameId: employeeNameId,
                });
              }
            });
          });

          setPlannedActivityHoursData(plannedHoursData);
          setEmployeeActivityHoursData({
            employeeHoursData: employeeHoursData,
            employeeHoursTotalData: employeeHoursTotalData,
          });
        }
          setActivityHoursDataLoading(false);
        })
        .catch((error) => {
          setPlannedActivityHoursData({});
          setEmployeeActivityHoursData({
            employeeHoursData: {},
            employeeHoursTotalData: {},
          });
          setActivityHoursDataLoading(false);
          console.log("getDscDashboardCollection err ", error);
        });
    } else {
      setPlannedActivityHoursData({});
      setEmployeeActivityHoursData({
        employeeHoursData: {},
        employeeHoursTotalData: {},
      });
      setActivityHoursDataLoading(false);
    }
  }, [selectedBuilding]);

  useEffect(() => {
    const buildingOptionsArray = districtBuildingMap[selectedDistrict];
    if (buildingOptionsArray) {
      setBuildingOptions(buildingOptionsArray);
    }
  }, [selectedDistrict]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
  };
  // const handleChecked = (e, index) => {
  //   console.log("hit", index);
  //   let prev = checked;
  //   let itemIndex = prev.indexOf(index);
  //   if (itemIndex !== -1) {
  //     prev.splice(itemIndex, 1);
  //   } else {
  //     prev.push(index);
  //   }
  //   setChecked([...prev]);
  //   setAnchorEl(null);

  //   let params = { ...checked };
  //   let filters;

  //   console.log("test", params);
  //   if (params) {
  //     if (Object.values(params).includes(0)) {
  //       console.log("leaves");
  //       filters = "Show Meal";
  //     }
  //     // if (Object.values(params).includes(1)) {
  //     //   console.log("meal");
  //     //   filters = "Show Meal";
  //     // }

  //     if (
  //       Object.values(params).includes(0) &&
  //       Object.values(params).includes(1)
  //     ) {
  //       filters = "Show Both";
  //     }
  //   }

  //   var startDate = moment().startOf("week").format("YYYY-MM-DD");
  //   var endDate = moment().endOf("week").format("YYYY-MM-DD");
  //   if (user.workerId) {
  //     getJobFamilyReportData(user.workerId, startDate, endDate, filters).then(
  //       (data) => {
  //         console.log("Job family report data", data);
  //         setJobFamilyChart(data);
  //         setJobFamilyChartLoading(false);
  //       }
  //     );
  //   }
  // };

  const ClockIn = (
    <CardLayout title={t("pgHome.lblClockedIn")}>
      <LoaderView loading={clockedInReportDataLoading}>
        <ClockedIn2 data={clockedInReportData} />
      </LoaderView>
    </CardLayout>
  );

  const EmpAct = (
    <CardLayout title={t("other.lblEmployeesActivities")}>
      <EmployeesActivities
        employeesUnderManager={employeesUnderManager}
        employeesUnderManagerLoading={employeesUnderManagerLoading}
      />
    </CardLayout>
  );

  const ActByJobRole = (
    <CardLayout
      // onClickMenu={handleClick}
      title={properCase(t("pgHome.report2"))}
    >
      <LoaderView loading={jobFamilyChartLoading && chartLoading}>
        <ActivityByJobRole jobFamilyChart={jobFamilyChart} chart={chart} />
        <Menu
          id="Menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {options.map((item, index) => {
            return (
              <ListItem alignItems="center" key={index}>
                {/* <Checkbox
                  edge="start"
                  checked={checked.includes(index)}
                  tabIndex={-1}
                  disableRipple
                  onChange={(e) => handleChecked(e, index)}
                /> */}
                <ListItemText dense primary={`${item.name}`} />
              </ListItem>
            );
          })}
        </Menu>
      </LoaderView>
    </CardLayout>
  );

  const ActHrsPlnd = (
    <CardLayout title={t("other.tlactivityHours")}>
      <ActivityHoursPlanned
        plannedActivityHoursData={plannedActivityHoursData}
        plannedActivityHoursDataLoading={activityHoursDataLoading}
        districtBuildingMapLoading={districtBuildingMapLoading}
      />
    </CardLayout>
  );

  const ActHrsByEmp = (
    <CardLayout title={t("other.lblActivityHoursByEmployee")}>
      <ActivityHoursByEmployee
        employeeActivityHoursData={employeeActivityHoursData}
        employeeActivityHoursDataLoading={activityHoursDataLoading}
        districtBuildingMapLoading={districtBuildingMapLoading}
      />
    </CardLayout>
  );

  const districtBuildingAutocomplete = (
    // <LoaderView loading={districtBuildingMapLoading}>
    <Grid
      container
      spacing={4}
      direction="row"
      // justifyContent="flex-end"
      alignItems="center"
    >
      <Grid item>
        <Autocomplete
          options={Object.keys(districtBuildingMap)}
          onChange={(event, newValue) => {
            if (newValue !== null) {
              setSelectedDistrict(newValue);
              setSelectedBuilding("");
            } else {
              setSelectedDistrict("");
              setSelectedBuilding("");
              setBuildingOptions([]);
            }
          }}
          style={{ width: 200 }}
          renderInput={(params) => {
            if (selectedDistrict === "") {
              return <TextField {...params} label="Select District" />;
            } else {
              return <TextField {...params} label="District" />;
            }
          }}
        />
      </Grid>
      <Grid item>
        <Autocomplete
          options={buildingOptions}
          onChange={(event, newValue) => {
            if (newValue !== null) {
              setSelectedBuilding(newValue);
            } else {
              setSelectedBuilding("");
            }
          }}
          value={selectedBuilding}
          style={{ width: 200 }}
          renderInput={(params) => {
            if (selectedBuilding === "") {
              return <TextField {...params} label="Select Building" />;
            } else {
              return <TextField {...params} label="Building" />;
            }
          }}
        />
      </Grid>
    </Grid>
    // </LoaderView>
  );

  const managerAutocomplete = (
    <Autocomplete
      options={MANAGE_FOR_BY_COUNTRY ? loggedinPlusDelegate : newOptions}
      getOptionLabel={(option) =>
        option && option.managerFirstName
          ? `${option.managerFirstName} ${option.managerLastName} (${option.managerId})`
          : ""
      }
      style={{ width: 200 }}
      value={selectedManager}
      onChange={(event, newValue) => {
        if (newValue !== null) {
          setSelectedManager(newValue);
        } else {
          setSelectedManager({});
        }
      }}
      renderInput={(params) => {
        if (isEmptyObject(selectedManager)) {
          return <TextField {...params} label="Select Manager" />;
        } else {
          return <TextField {...params} label="Manager" />;
        }
      }}
    />
  );

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid container item alignItems="center">
          <Grid item xs={6}>
            {managerAutocomplete}
          </Grid>
          <Grid item xs={6}>
            {districtBuildingAutocomplete}
          </Grid>
        </Grid>
        <Grid container item spacing={2}>
          <Grid container spacing={2} direction="column" xs={6} item>
            {/* <Grid item>{managerAutocomplete}</Grid> */}
            <Grid item>{ClockIn}</Grid>
            <Grid item>{ActByJobRole}</Grid>
            <Grid item>{EmpAct}</Grid>
          </Grid>
          <Grid container spacing={2} direction="column" xs={6} item>
            {/* <Grid item>{districtBuildingAutocomplete}</Grid> */}
            <Grid item>{ActHrsPlnd}</Grid>
            <Grid item>{ActHrsByEmp}</Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default HomeView;
